import { ShoppingProcessType } from "InitialData/constant";
import Dummy from "components/Dummy";
import P from "components/P";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { QRCodeSVG } from "qrcode.react";
import { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import closeIcon from "resources/img/puffu/close.png";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import downIcon from "resources/img/puffu/downAngle.png";
import style from "./HorizontalPaymentStep.module.css";
import { requester } from "App";
import { toast } from "react-toastify";
import categorySound from "resources/music/물방울.mp3";
import qrSound from "resources/music/two/audio_1_QR코드를_스마트폰_카메라나_푸푸앱으로_찍어_결제하세요_.mp3";
import homeBtnIcon from "resources/img/puffu/homebtn.svg";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { ReactComponent as DummyQr } from "resources/img/dummyQr.svg";
import TrashIcon from "resources/img/icons/TrashIcon";



function HorizontalPaymentStep2(props) {
    const { id } = useParams();
    const { isMobile } = useContext(BrowserDetectContext);
    const { setViewData } = useOutletContext();
    const audioRef = useRef();
    const audio1Ref = useRef();
    const dispatch = useDispatch();
    const [isMounted, setMounted] = useState();
    const cartData = useSelector((state) => state.cart.products);
    const isLoading = useSelector((state) => state.history.isLoading);
    const [cartList, setCartList] = useState([]);
    const [paymentResult, setPaymentResult] = useState();
    const [total, setTotal] = useState(0);
    const [showArrows, setShowArrows] = useState(false);
    const [completeArrow, setCompleteArrow] = useState(false);
    const currentProcess = ShoppingProcessType.ORDER;
    const navigate = useNavigate();
    const location = useLocation();

    const isDev = process.env.REACT_APP_ENV === "development";

    useEffect(() => {
        // let data = {
        //     title: "",
        //     footterButtonText: "",
        //     currentProcess: currentProcess,
        //     totalCount: 0,
        //     selectedCount: 0,
        //     priceSum: 0,
        //     vat: 0,
        //     deliveryFee: 0,
        //     discountSum: 0,
        //     totalAmount: 0,
        //     onDeleteSelectedProductsClick: () => { },
        //     onSubmitButtonClick: () => { },
        //     detailYn: false,
        //     detailProduct: null
        // };
        // setViewData(data);
        setViewData(prevData => ({
            ...prevData,
            title: "",
            footterButtonText: "",
            currentProcess: currentProcess,
            totalCount: 0,
            selectedCount: 0,
            priceSum: 0,
            vat: 0,
            deliveryFee: 0,
            discountSum: 0,
            totalAmount: 0,
            onDeleteSelectedProductsClick: () => { },
            onSubmitButtonClick: () => { },
            detailYn: false,
            detailProduct: null
        }));
        setMounted(true);
        audio1Ref.current.play();
    }, []);

    useEffect(() => {
        setCartList(cartData);
        if (cartData.length > 2 && completeArrow === false) {
            setShowArrows(true);
            setCompleteArrow(true);
            const timer = setTimeout(() => {
                setShowArrows(false);
            }, 20000);

            return () => clearTimeout(timer);
        }
        if (cartData.length === 0) {
            // navigate(`/ws/${id}/horizontal2/main2`, { state: { category: location.state.category } })
            navigate(`/ws/${id}/main`, { state: { category: location.state.category } })
        }
    }, [cartData]);

    useEffect(() => {
        if (cartList && cartList.length > 0) {
            const totalPrice = cartList.reduce((total, item) => {
                return total + (item.quantity * item.price);
            }, 0);
            setTotal(totalPrice);
            TestOnClick();
        }
    }, [cartList]);



    const PaymentQR = () => {
        if (!paymentResult) {
            return (
                <div className={style.qrWrapper}>
                    <div className={`${style.qrPlaceholder} ${isLoading ? style.blur : ''}`}>
                        <DummyQr />
                    </div>
                    <div className={style.qrCornerAnimation}>
                        <div className={style.topRightCorner}></div>
                        <div className={style.bottomLeftCorner}></div>
                    </div>
                </div>
            );
        }

        // 기존의 QR 코드 렌더링 로직 유지
        const extractedData = cartList.map(item => ({
            locationNo: item.locationNo,
            quantity: item.quantity,
            deviceId: item.deviceId
        }));
        const extractedValues = extractedData.map(item => {
            // const deviceIdSuffix = item.deviceId ? item.deviceId.slice(-3) : '';
            const deviceIdSuffix = item.deviceId ? item.deviceId : '';
            return [item.locationNo, item.quantity, deviceIdSuffix];
        });
        const trxId = paymentResult && paymentResult.link.trxId;
        const trackId = paymentResult && paymentResult.link.trackId;
        const amount = paymentResult && paymentResult.link.amount;
        const storeCode = paymentResult && paymentResult.link.udf1;
        const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";
        const jsonData = extractedValues;
        const jsonString = JSON.stringify(jsonData);
        const base64EncodedString = btoa(jsonString);
        const param = `data=${base64EncodedString}`;

        const paymentHistoryId = paymentResult && paymentResult.paymentHistoryId;
        return (
            <div className={style.qrWrapper}>
                <QRCodeSVG
                    // value={`https://puffuapp.com/ws/${id}/landingGateWay?${param}&trxId=${trxId}&trackId=${trackId}&amount=${amount}&storeCode=${storeCode}&deviceCode=${deviceCode}`}
                    // value={`http://175.213.135.218:13000/ws/${id}/paymentHistory?id=${paymentHistoryId}`}
                    value={`${process.env.REACT_APP_FRONT}ws/${id}/paymentHistory?id=${paymentHistoryId}`}
                    // value={`https://puffuapp.com/ws/${id}/paymentHistory?id=${paymentHistoryId}`}
                    size={"13vw"}
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    level={"L"}
                    includeMargin={false}
                />
                <div className={style.qrCornerAnimation}>
                    <div className={style.topRightCorner}></div>
                    <div className={style.bottomLeftCorner}></div>
                </div>
            </div>
        );
    };


    const TestOnClick = () => {
        dispatch(HistoryReducer.actions.setLoading(true));

        const newTotal = cartData.reduce((acc, item) => acc + item.quantity * item.price, 0);
        const extractedData = cartList.map(item => ({
            locationNo: item.locationNo,
            quantity: item.quantity,
            deviceId: item.deviceId
        }));
        const extractedValues = extractedData.map(item => {
            // const deviceIdSuffix = item.deviceId ? item.deviceId.slice(-3) : '';
            const deviceIdSuffix = item.deviceId ? item.deviceId : '';
            return [item.locationNo, item.quantity, deviceIdSuffix];
        });
        const jsonMachineData = extractedValues;
        const jsonMachineString = JSON.stringify(jsonMachineData);
        const base64EncodedString = btoa(jsonMachineString);
        const deviceCodeData = window.BRIDGE && window.BRIDGE.getDeviceCode() ? window.BRIDGE.getDeviceCode() : null;


        let data = {
            orderProducts: cartData,
            amount: newTotal,
            userName: "",
            storeCode: id,
            machineData: base64EncodedString,
            deviceCode: deviceCodeData,
            // returnUrl: 'https://puffuapp.com/ws/5/mobile'
            // returnUrl: `http://175.213.135.218:13000/ws/${id}/mobile`
            returnUrl: `${process.env.REACT_APP_FRONT}ws/${id}/mobile`
        };
        if (cartData && cartData.length > 0) {
            if (isDev) {
                requester.testPaymentRequest(data, (result) => { // 테스트 결제
                    if (result.code === 0) {
                        let ready = result.data;
                        requester.testPayment(ready, (result) => {  // 테스트 결제
                            if (result.code === 0) {
                                setPaymentResult(result.data);
                                dispatch(HistoryReducer.actions.setLoading(false));

                                const jsonString = JSON.stringify(result.data);
                                if (window.BRIDGE && window.BRIDGE.sendPaymentResult) {
                                    window.BRIDGE.sendPaymentResult(jsonString);
                                }
                            }
                        })
                    } else {
                        dispatch(HistoryReducer.actions.setLoading(false));
                        toast.error("테스트 결제 중 문제가 발생했습니다 관리자에게 문의하세요", {
                            autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                        });
                    }
                })
            } else (
                requester.paymentRequest(data, (result) => { // 실결제
                    if (result.code === 0) {
                        let ready = result.data;
                        requester.payment(ready, (result) => { // 실결제
                            if (result.code === 0) {
                                setPaymentResult(result.data);
                                dispatch(HistoryReducer.actions.setLoading(false));

                                const jsonString = JSON.stringify(result.data);
                                if (window.BRIDGE && window.BRIDGE.sendPaymentResult) {
                                    window.BRIDGE.sendPaymentResult(jsonString);
                                }
                            }
                        })
                    } else {
                        dispatch(HistoryReducer.actions.setLoading(false));
                        toast.error("결제 중 문제가 발생했습니다 관리자에게 문의하세요", {
                            autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                        });
                    }
                })
            )
        } else {
            dispatch(HistoryReducer.actions.setLoading(false));
            toast.error("장바구니에 물건이 없습니다.", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        }
    };


    const Product = (props) => {
        const { data } = props;
        const deleteCartProductClick = (e) => {
            setPaymentResult('')
            e.stopPropagation();
            // dispatch(CartReducer.actions.removeProductFromCart(data));
            let deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode() ? window.BRIDGE.getDeviceCode() : null;
            const cartData = {
                roomId: id,
                code: "removeProductFromCart",
                cartList: [{ id: data.id }],
                deviceCode: deviceCode
            }

            requester.testOrder(cartData, (result) => {
            });
            audioRef.current.play();
        }
        return (
            <FlexChild >
                <VerticalFlex >
                    <FlexChild width={"95%"} padding={"10px 0"}>
                        <HorizontalFlex gap={10}>
                            <FlexChild width={"20%"} height={"138px"} justifyContent={"center"}>
                                <img src={data.productImg} width={"auto"} height={"100%"} style={{ transform: "translateX(-15px)" }} />
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex gap={10}>
                                    <FlexChild>
                                        <Center width={"100%"} textAlign={"left"}>
                                            <P size={"1.7vw"} >
                                                {data.productName}  {data.quantity}개
                                            </P>
                                        </Center>
                                    </FlexChild>
                                    <FlexChild>
                                        <Center width={"100%"} textAlign={"left"}>
                                            <P size={"1.7vw"} weight={"bold"} >
                                                {(data.price * data.quantity).toLocaleString()}원
                                            </P>
                                        </Center>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"} width={40}>
                                {/* <img src={closeIcon} className={style.closeBtn} style={{ width: "30px", filter: "invert(60%)", position: "relative", right: "30px" , pointerEvents: showArrows ? "none" : "auto" }} onPointerUp={deleteCartProductClick}/> */}
                                <div style={{ width: 'max-content', display: 'flex', justifyContent: 'center' }} onPointerUp={deleteCartProductClick}>
                                    <TrashIcon width={56} height={56} onPointerUp={deleteCartProductClick} />
                                </div>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    {
                        props.line
                            ?
                            null
                            :
                            <FlexChild>
                                <div
                                    style={{
                                        width: "100%",
                                        height: "1px",
                                        backgroundColor: "rgba(225, 225, 225, 1)",
                                    }}
                                />
                            </FlexChild>
                    }
                </VerticalFlex>
            </FlexChild>

        );
    }

    const onCloseClick = () => {
        audioRef.current.play();
        setCompleteArrow(false);
        setViewData(prevData => ({
            ...prevData,
            currentProcess: ShoppingProcessType.CART
        }));
        // navigate(`/ws/${id}/horizontal2/main2`, { state: { category: location.state.category } })
        navigate(`/ws/${id}/main`, { state: { category: location.state.category } })
    }
    const NumberText = (props) => {
        const { number, content } = props;
        return (
            <HorizontalFlex gap={10}>
                <FlexChild width={"max-content"} >
                    <div style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        border: "1.5px solid rgba(232, 69, 99, 1)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <P weight={700} color={"rgba(232, 69, 99, 1)"}>{number}</P>
                    </div>
                </FlexChild>
                <FlexChild>
                    <P weight={500} size={20}>{content}</P>
                </FlexChild>
            </HorizontalFlex>
        );
    }

    const onScrollGuideClick = (e) => {
        e.stopPropagation();
        setShowArrows(false);
        setCompleteArrow(true);
    };


    return (
        <div style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
            <audio ref={audioRef} src={categorySound} preload="auto" />
            <audio ref={audio1Ref} src={qrSound} preload="auto" />
            <Dummy height={"35px"} />
            <div style={{ border: "1.5px solid var(--point-color)", borderRadius: "7px", position: "relative", padding: "60px 0", width: "93%", height: "870px", backgroundColor: "white" }}>
                <div style={{ position: 'absolute', top: '10px', right: "23px", width: 'max-content' }}>
                    <div
                        onPointerUp={onCloseClick}
                        className={style.closeBtn}
                        style={{ width: '241px', height: "53px", backgroundColor: "white", border: "1.5px solid var(--main-color)", borderRadius: "3px" }}
                    >
                        <Center>
                            <Inline>
                                <img src={homeBtnIcon} width={"30px"} />
                                <Dummy width={"15px"} />
                                <P color={"var(--main-color)"} weight={900} font={"Pretendard"} size={"1.5vw"}>뒤로가기</P>
                            </Inline>
                        </Center>
                    </div>
                </div>
                {/* <div className={style.closeBtn} style={{ position: "absolute", top: '28px', width: "max-content", left: "95.2%" }} onPointerUp={onCloseClick}>
                    <img src={closeIcon} width={"40px"} style={{ filter: "invert(60%)", position: "relative", right: 0 }} />
                </div> */}
                <VerticalFlex gap={40}>

                    <FlexChild width={"90%"}>
                        <HorizontalFlex>
                            <FlexChild>
                                <FlexChild>
                                    <VerticalFlex>
                                        <FlexChild alignItems={"flex-start"}>
                                            <P color={"#FE531F"} weight={"bold"} size={40}>
                                                총 {cartList.length}개 상품
                                            </P>
                                            <P color={"black"} weight={"bold"} size={40}>
                                                {total.toLocaleString()}원
                                            </P>
                                        </FlexChild>
                                        <FlexChild height={"90px"} />
                                        <FlexChild alignItems={"flex-start"}>
                                            <P color={"black"} weight={700} size={40}>
                                                QR코드를 카메라로 스캔해 앱으로 결제하세요.
                                            </P>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"} padding={"0 20px 0 0"}>
                                <PaymentQR />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild width={"90%"}>
                        <VerticalFlex gap={10} flexStart>
                            <FlexChild height={"max-content"}>
                                <div
                                    style={{
                                        width: "100%",
                                        height: "1px",
                                        backgroundColor: "rgba(225, 225, 225, 1)",
                                    }}
                                />
                            </FlexChild>
                            <div style={{ height: "max-content", position: "relative" }}>
                                {showArrows && (
                                    <div style={{ width: "100%", position: "absolute", zIndex: "10" }} onPointerDown={onScrollGuideClick}>
                                        <div className={style.downAngleContainer}>
                                            <P textAlign={"center"} weight={700} size={22} color={"white"}>스크롤하여</P>
                                            <P textAlign={"center"} weight={700} size={22} color={"white"}>상품을 확인해주세요</P>
                                            <Dummy height={"10px"} />
                                            <img src={downIcon} className={`${style.downAngle} ${style.downAngle1}`} style={{ filter: "invert(100%)" }} />
                                            <img src={downIcon} className={`${style.downAngle} ${style.downAngle2}`} style={{ filter: "invert(100%)" }} />
                                            <img src={downIcon} className={`${style.downAngle} ${style.downAngle3}`} style={{ filter: "invert(100%)" }} />
                                        </div>
                                    </div>
                                )}
                                <div style={{ overflow: "hidden", maxHeight: "350px", display: "flex", flexDirection: "column", overflowY: "scroll" }}>
                                    {
                                        cartList.map((data, index) => {
                                            const isLastElement = index === cartList.length - 1;
                                            return <Product data={data} />;
                                        })
                                    }
                                </div>
                            </div>
                        </VerticalFlex>
                    </FlexChild>

                </VerticalFlex>
            </div >
        </div >

    );
}

export default HorizontalPaymentStep2;